module.exports = __webpack_public_path__ + "media/application/images/ui/badge-peoples-choice-87c678b9f89871d268f4dca3bdd6c5b7.png";